import { clinicInfo } from "@/mocks/site";

/**
 * Floating WhatsApp chat button, visible on every page at the bottom-right.
 * It sits above the mobile Call / Book bar so nothing important is covered.
 */
export default function WhatsAppFloat() {
  return (
    <div className="pointer-events-none fixed bottom-20 right-4 z-40 flex flex-col items-end gap-2 md:bottom-6 md:right-6">
      <a
        href={clinicInfo.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
        className="pointer-events-auto group flex cursor-pointer items-center gap-2"
      >
        <span className="hidden rounded-full border border-background-200 bg-background-50/95 px-3.5 py-2 font-label text-xs font-semibold text-foreground-800 backdrop-blur transition-opacity duration-200 md:block md:opacity-0 md:group-hover:opacity-100">
          Chat with us on WhatsApp
        </span>
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] ring-4 ring-background-50/70 transition-transform duration-200 group-hover:scale-105">
          <i className="ri-whatsapp-fill text-3xl leading-none text-white" aria-hidden="true"></i>
        </span>
      </a>
    </div>
  );
}